import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ASAP_TIME } from '../libs/polygon-ordering/src/constants';

const initialState: DeliveryAddressForm = {
  page: 'DeliveryTimeAndAddressSelection',
  modalHeight: 100,
  addressSuggestions: [],
  deliveryTime: ASAP_TIME,
  showTimePicker: false,
  submittingForm: false,
  addressSelectionView: 'Map',
  adjustingPin: false,
  resetMapCenter: false,
};

const slice = createSlice({
  name: 'deliveryAddressForm',
  initialState: initialState,
  reducers: {
    updateForm(state, action: PayloadAction<Partial<DeliveryAddressForm>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetForm(_state) {
      return initialState;
    },
    setSelectedAddress(state, action: PayloadAction<DeliveryAddress | undefined>) {
      if (!state.selectedAddress) {
        state.selectedAddress = action.payload;
        return state;
      }

      state.selectedAddress = {
        ...state.selectedAddress,
        ...action.payload,
      };

      if (!action.payload?.addressId) {
        delete state.selectedAddress.addressId;
      }

      return state;
    },
  },
});

export const { updateForm, resetForm, setSelectedAddress } = slice.actions;

export default slice.reducer;
